// extracted by mini-css-extract-plugin
export default {"circle-tiny":"Button_circle-tiny__YSZuf","showAsIcon":"Button_showAsIcon__jUYlK"};